angular.module('logbook')
.directive('dragDrop',['$rootScope', '$timeout', function($rootScope, $timeout)
{
	return {
		restrict: 'A',
		scope: {
			isDraggable: '=',
			isDropTarget: '=',
			data: '='
		},
		link: {
			pre: function(scope, element, attrs)
			{
				var isDraggable = !!scope.isDraggable;
				var isDropTarget = !!scope.isDropTarget;
				scope.element = element;
				if (isDraggable)
				{
					element.bind('dragstart', function($event){
						$rootScope.$broadcast('elementDragStart', $event, scope.data, element);
					});
					
					element.bind('dragend', function($event){
						$rootScope.$broadcast('elementDragEnd', $event, scope.data, element);
						if (!!scope.hasHandle)
							$(element).attr('draggable', false);
					})
				}
				
				if (isDropTarget)
				{
					element.bind('drop', function($event){
						$rootScope.$broadcast('elementDropped', $event, scope.data, element);
					});
					
					element.bind('dragenter', function($event){
						$event.preventDefault();
						$rootScope.$broadcast('elementDragEnter', $event, scope.data, element);
					})
					
					element.bind('dragover', function($event){
						$event.preventDefault();
						$rootScope.$broadcast('elementDragOver', $event, scope.data, element);
					})
					
					element.bind('dragleave', function($event){
						$rootScope.$broadcast('elementDragLeave', $event, scope.data, element);
					})
				}
			},
			
			post: function(scope, element, attr)
			{
				$timeout(function()
				{
					var isDraggable = !!scope.isDraggable;
					var isDropTarget = !!scope.isDropTarget;
					
					var handle = $(element).find('[draggable-handle]');
					var hasHandle = scope.hasHandle = !!handle.length && isDraggable;
					
					// If a handle is found, only allow dragging when starting from handle
					if (hasHandle)
					{
						handle.bind('mousedown', function()
						{
							$(element).attr('draggable', true);
						})
						
						handle.bind('touchmove', function()
						{
							$(element).attr('draggable', true);
						})
						
						handle.bind('mouseup', function()
						{
							$(element).attr('draggable', false);
						})
					}
					else
					{
						$(element).attr('draggable', isDraggable);
					}
				})
				
			}
		}
	}
}])